import fetch from '@adc/fetch'
import { gql } from '@adc/sdk'

/** @type {(variables: any) => Promise<any>} */
export async function saveFirstLookBuyerSelection(variables) {
  return await fetch.forAuctionGraph({
    query: gql`
      mutation resiPdp_firstLookBuyerSelectionSave(
        $listing_id: ID!
        $signature: String!
        $buyer_selection: FirstLookBuyerSelectionType!
      ) {
        saveFirstLookBuyerSelection(
          input: {
            listing_id: $listing_id
            signature: $signature
            buyer_selection: $buyer_selection
          }
        ) {
          first_look_buyer_selection_id
          party_id
          property_id
          buyer_selection
          is_first_look_qualified
          first_look_expiration_date
        }
      }
    `,
    variables,
  })
}
